import { useTranslation } from 'react-i18next';
import { Encabezado } from '../componentes/ui/basicos';
import { useSesion } from '../sesion/ProveedorDeSesion';
import { Preparacion } from '../componentes/Preparacion';
import { LoQueEspera } from '../componentes/LoQueEspera';
import { QueHacerHoy } from '../componentes/QueHacerHoy';
import { Tablero } from '../componentes/Tablero';

/**
 * Inicio.
 *
 * **La tarjeta «Tu acceso» ya no está.** Decía el correo de la persona —que ya está en la barra
 * superior— y la cantidad de permisos de su rol, que es un número de desarrollador: nadie de un
 * comercio necesita saber que tiene 104. Lo que le sirve a quien entra es cómo viene el día.
 *
 * El tablero va arriba y la preparación arriba de todo: lo que le falta al comercio para
 * poder operar gana sobre cualquier número, porque un tablero en cero por no haber configurado un
 * punto de venta se lee como «no vendimos nada» y es otra cosa.
 */
export function Inicio(): React.ReactElement {
  const { t } = useTranslation();
  const { perfil, empresaActivaId } = useSesion();
  const empresa = perfil?.empresas.find((posible) => posible.empresaId === empresaActivaId);

  return (
    <>
      <Encabezado titulo={empresa?.nombre ?? ''} descripcion={t('inicio.descripcion')} />

      {/* Arriba de todo y en la primera pantalla que alguien ve. Lo que le falta al comercio para
          operar no sirve escondido en una pantalla de administración: sirve donde se entra. */}
      <Preparacion />
      {/* Los pendientes van arriba del tablero: el tablero dice cómo viene el día y esto dice qué
          hay que hacer con él. Lo segundo se acciona; lo primero se mira. */}
      <QueHacerHoy />
      <LoQueEspera />
      <Tablero />
    </>
  );
}
